import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';

import './styles.scss';

const componentBaseClass = 'qoc-main-layout-container';

function GeneralLayout(props = {}) {
  console.log('-- GeneralLayout props: ', props);
  const { children } = props;

  return (
    <div className={componentBaseClass}>
      <div className="row no-gutters">
        <div className="col-xs-12 col-sm">
          <div className={`${componentBaseClass}__content`}>{children}</div>
        </div>
      </div>
    </div>
  );
}

GeneralLayout.propTypes = {
  children: PropTypes.node
};

GeneralLayout.defaultProps = {
  children: null
};

export default withRouter(GeneralLayout);
